import ColorChangableAxis from '@/components/ColorChangableAxis/ColorChangableAxis.vue';
import SkeletonLoadingImage from '@/components/SkeletonLoadingImage/SkeletonLoadingImage.vue';

const PIE_PERCENT = 6.25;

export default {
	name: 'FormatMenu',
	components: { ColorChangableAxis, SkeletonLoadingImage },
	props: {
		formatMenuData: {
			type: Object,
		},
		disabled: {
			type: Boolean,
		},
		titleCaption: {
			type: String,
		},
		isShowScrollButton: {
			type: Boolean,
			defaut: false
		}
	},
	data() {
		return {
			checked: false,
			/**
			 * Unit: degree
			 */
			pieAngle: 22.5,
			/**
			 * List of index of pie chart items corresponding to the formatMenuData.designTates array
			 */
			quaterCircleLefts: [15, 14, 13, 12, 7, 6, 5, 4],
			quaterCircleRights: [0, 1, 2, 3, 8, 9, 10, 11],
		};
	},

	computed: {
		pieChartStyle() {
			let gradientValue = '';
			let tempDesignTastes = [...this.formatMenuData?.designTastes];
			if (tempDesignTastes.length === 0) return;

			// Swap element due to displaying correct ordering on chart
			// Using destructuring assignment
			[
				tempDesignTastes[4],
				tempDesignTastes[5],
				tempDesignTastes[6],
				tempDesignTastes[7],
				tempDesignTastes[8],
				tempDesignTastes[9],
				tempDesignTastes[10],
				tempDesignTastes[11],
			] = [
				tempDesignTastes[8],
				tempDesignTastes[9],
				tempDesignTastes[10],
				tempDesignTastes[11],
				tempDesignTastes[4],
				tempDesignTastes[5],
				tempDesignTastes[6],
				tempDesignTastes[7],
			];

			tempDesignTastes.map((el, index) => {
				const color = el.value ? 'black' : 'transparent';
				gradientValue +=
					`${color} ${index * PIE_PERCENT}% ${(index + 1) * PIE_PERCENT}%` + ',';
			});

			// Remove last comma
			gradientValue = gradientValue.slice(0, -1);

			return `conic-gradient(${gradientValue})`;
		},
	},

	methods: {
		/**
		 *
		 * @param {String} type descibe type of format is selected
		 * @param {Integer} idx index of item selected
		 * @param {Boolean} isInput indicate that input is selected or not
		 * If true: no update value because of binding v-model
		 * if false: update value without binding v-model
		 */
		onChange(type, idx, isInput) {
			let currentValue = this.formatMenuData[`${type}`][idx].value;

			if (!isInput) {
				// Update curent value
				this.formatMenuData[`${type}`][idx].value = Number(!currentValue);
				currentValue = Number(!currentValue);
			}

			console.log('VALUE', currentValue);
			this.$emit('on-change', { type, idx, value: currentValue });
		},

		onChangeText(event, type) {
			this.$emit('on-change-text', { type, value: event.target.value });
		},

		/**
		 * Handle click event on pie chart
		 * @param {Integer} index index of current slide pie of chart
		 */
		onQuaterCircleClick(index) {
			if (this.disabled) return;

			let currentValue = this.formatMenuData.designTastes[index].value;

			// Update curent value
			this.formatMenuData.designTastes[index].value = Number(!currentValue);
			currentValue = Number(!currentValue);

			console.log('VALUE', currentValue);
			this.$emit('on-change', {
				type: 'designTastes',
				idx: index,
				value: currentValue,
			});
		},
		onClickingSelectedArea(id) {
			this.$emit('on-clicking-selected-area', id);
		},
	},
};
